import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.put("/admin/password", { current_password: current, new_password: next });
      toast.success("Contraseña actualizada");
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al cambiar contraseña");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-zinc-950/80 flex items-center justify-center p-4" onClick={onClose}>
      <form onClick={(e) => e.stopPropagation()} onSubmit={submit} className="bg-white rounded-2xl p-6 w-full max-w-sm">
        <h3 className="text-xl font-black text-zinc-900 mb-1">Cambiar contraseña</h3>
        <p className="text-sm text-zinc-600 mb-5">Cambia la clave por defecto (12345).</p>
        <Label className="text-sm font-bold mb-1 block">Contraseña actual</Label>
        <Input data-testid="admin-current-pw" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="h-12 mb-3" />
        <Label className="text-sm font-bold mb-1 block">Nueva contraseña</Label>
        <Input data-testid="admin-new-pw" type="password" value={next} onChange={(e) => setNext(e.target.value)} className="h-12 mb-5" />
        <div className="flex gap-2">
          <Button type="button" variant="outline" onClick={onClose} className="flex-1 h-12">Cancelar</Button>
          <Button data-testid="admin-save-pw" type="submit" disabled={submitting} className="flex-1 h-12 bg-zinc-900 text-white">
            {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Guardar"}
          </Button>
        </div>
      </form>
    </div>
  );
}
